(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAntesDespues() {
    document.querySelectorAll("[data-mt-ad]").forEach(function (wrap) {
      var after = wrap.querySelector(".mt-ad-after");
      var handle = wrap.querySelector(".mt-ad-handle");
      if (!after || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = "inset(0 0 0 " + pct + "%)";
        handle.style.left = pct + "%";
      }

      wrap.addEventListener("pointerdown", function (e) {
        dragging = true;
        setPos(e.clientX);
      });
      window.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      window.addEventListener("pointerup", function () { dragging = false; });
      wrap.addEventListener("mousemove", function (e) {
        if (dragging) setPos(e.clientX);
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-galeria-principal]");
      var thumbs = galeria.querySelectorAll("[data-mt-galeria-thumb]");
      if (!principal || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-full");
          if (!src) return;
          principal.src = src;
          thumbs.forEach(function (t) { t.classList.remove("mt-activa"); });
          thumb.classList.add("mt-activa");
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll(".mt-form-producto").forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var contenedor = form.closest("[data-mt-producto-compra]") || form;
      var idInput = form.querySelector('input[name="id"]');
      var botonesGrupo = contenedor.querySelectorAll("[data-mt-opcion]");
      var precioEl = contenedor.querySelector("[data-mt-precio]");
      var precioTachadoEl = contenedor.querySelector("[data-mt-precio-tachado]");
      var submitBtn = form.querySelector('button[type="submit"]');

      function seleccionActual() {
        var sel = [];
        contenedor.querySelectorAll("[data-mt-opcion]").forEach(function (grupo) {
          var activo = grupo.querySelector(".mt-seleccionada");
          if (activo) sel.push(activo.getAttribute("data-valor"));
        });
        return sel;
      }

      function actualizar() {
        var sel = seleccionActual();
        var match = variantes.find(function (v) {
          return v.opciones.length === sel.length && v.opciones.every(function (o, i) { return o === sel[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (precioEl) precioEl.textContent = match.precio;
        if (precioTachadoEl) {
          if (match.precioTachado) {
            precioTachadoEl.textContent = match.precioTachado;
            precioTachadoEl.style.display = "";
          } else {
            precioTachadoEl.style.display = "none";
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !match.disponible;
          submitBtn.textContent = match.disponible ? submitBtn.getAttribute("data-texto-disponible") : submitBtn.getAttribute("data-texto-agotado");
        }
      }

      botonesGrupo.forEach(function (grupo) {
        grupo.querySelectorAll("[data-valor]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            grupo.querySelectorAll("[data-valor]").forEach(function (b) { b.classList.remove("mt-seleccionada"); });
            btn.classList.add("mt-seleccionada");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initAntesDespues();
    initGaleria();
    initVariantes();
  });
})();
